import { useTranslation } from "react-i18next";
import Counter from "@/components/Counter/Counter";
import IconButton from "@/components/IconButton/IconButton";
import SummaryItemComponent from "@/components/SummaryItemComponent/SummaryItemComponent";
import TransparentTile from "@/components/TransparentTile/TransparentTile";
import { getTranslation } from "@/helpers/getTranslation";
import {
  formatGrosze,
  lineTotalGrosze,
  lineUnitPriceGrosze,
} from "@/helpers/cartPricing";
import type { CartLine } from "@/types/order";
import styles from "./CartLineTile.module.scss";

interface CartLineTileProps {
  line: CartLine;
  language: string;
  unavailable?: boolean;
  onQuantityChange: (quantity: number) => void;
  onRemove: () => void;
}

function CartLineTile(props: CartLineTileProps) {
  const { line, language, unavailable, onQuantityChange, onRemove } = props;
  const { t } = useTranslation();

  return (
    <TransparentTile>
      <>
        <SummaryItemComponent
          count={line.quantity}
          description={getTranslation(line.translations, language)}
          size={
            line.size ? getTranslation(line.size.translations, language) : undefined
          }
          basePrice={
            line.quantity > 1
              ? formatGrosze(lineUnitPriceGrosze(line))
              : undefined
          }
          price={formatGrosze(lineTotalGrosze(line))}
          extraNote={line.extraNote}
          toppings={line.toppings.map((topping) => ({
            name: getTranslation(topping.translations, language),
            price: formatGrosze(topping.price),
            count: topping.quantity,
          }))}
          actions={
            line.isReward ? (
              <p className={`body-bold-medium ${styles.cartLineReward}`}>
                {t("order.cart.reward")}
              </p>
            ) : (
              <>
                <Counter
                  value={line.quantity}
                  onChange={onQuantityChange}
                  min={1}
                />
                <IconButton
                  iconName="las la-trash-alt icon-xl"
                  onClick={onRemove}
                  color="primary"
                  variant="text"
                />
              </>
            )
          }
        />
        {unavailable ? (
          <p className={`body-medium ${styles.cartLineUnavailable}`}>
            {t("order.cart.unavailable")}. {t("order.cart.unavailableHint")}
          </p>
        ) : null}
      </>
    </TransparentTile>
  );
}

export default CartLineTile;
